import { call, put, takeLatest } from 'redux-saga/effects';
import NotificationAction, { NotificationTypes } from 'redux/actions/notificationAction';
import NotificationServices from 'services/notificationServices';
import BaseAction from '../actions/baseAction';

export function* sendNotifications(action: any): any {
  const { params } = action;

  try {
    const result = yield call(NotificationServices.sendNotification, params);
    yield put(NotificationAction.sendNotificationSuccess(result));
  } catch (error){
    yield put(BaseAction.errorHandling({
        message: `SEND_NOTIFICATION ${error}`
      }));
  }
};
export const watchNotification = [
  takeLatest(NotificationTypes.SEND_NOTIFICATION, sendNotifications)
];
